module.exports = __webpack_public_path__ + "images/interview-Indeed-2.svg";